import React, { createContext, useContext, useState, ReactNode, useMemo, useCallback } from 'react';
import { ITransactionRestrictions } from '../interface/transactionRestriction';

interface TransactionRestrictionsContextType {
  transactionRestrictions: ITransactionRestrictions | null;
  updateTransactionRestrictions: (transaction: ITransactionRestrictions | null) => void;
}

const TransactionRestrictionsContext = createContext<
  TransactionRestrictionsContextType | undefined
>(undefined);

export const TransactionRestrictionsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [transactionRestrictions, setTransactionRestrictions] =
    useState<ITransactionRestrictions | null>(null);

  const updateTransactionRestrictions = useCallback((data: ITransactionRestrictions | null) => {
    setTransactionRestrictions(data);
  }, []);

  const transactionRestrictionsContextValue = useMemo(
    () => ({ transactionRestrictions, updateTransactionRestrictions }),
    [transactionRestrictions, updateTransactionRestrictions],
  );
  return (
    <TransactionRestrictionsContext.Provider value={transactionRestrictionsContextValue}>
      {children}
    </TransactionRestrictionsContext.Provider>
  );
};

export const useTransactionRestrictions = () => {
  const context = useContext(TransactionRestrictionsContext);
  if (!context) {
    throw new Error('useTransactionRestrictions must be used within a TransactionProvider');
  }
  return context;
};
